Component(function ($context) {
    return $context.select('.promo-block');
}, function ($block) {
    $block.on('click', '.promo-block__toggle-categories', function () {
        const $categories = $block.find('.promo-block__card-categories');
        const isHidden = $categories.hasClass('promo-block__card-categories_hidden');
        const height = isHidden ? $categories.prop('scrollHeight') : $categories.data('mobile-height');

        $categories.animate({height: height})
        $(this).toggleClass('promo-block__toggle-categories_active')
        $categories.toggleClass('promo-block__card-categories_hidden')
    })
});